import styled from 'styled-components';

export const PurchaseResume = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Total = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0em;
  text-align: right;
  color: #4d4d4d;
`;
